import { NgModule } from '@angular/core';
import { TaskService } from '../Task/task.service.upgrade';
import { ActionViewPersistenceService } from '../Task/ActionView/Action.View.Persistence.Service.upgrade';
import { ActionViewService } from '../Task/ActionView/action-view-service.upgrade';
import { StartupService } from './startup.service.upgrade';

@NgModule({
    providers: [
        { provide: '$location', useFactory: (i: any) => i.get('$location'), deps: ['$injector'] },
        { provide: '$http', useFactory: (i: any) => i.get('$http'), deps: ['$injector'] },
        {
            provide: ActionViewPersistenceService,
            useFactory: (i: any) => i.get('actionViewPersistenceService'),
            deps: ['$injector'],
        },
        { provide: ActionViewService, useFactory: (i: any) => i.get('actionViewService'), deps: ['$injector'] },
        { provide: '$rootScope', useFactory: (i: any) => i.get('$rootScope'), deps: ['$injector'] },
        { provide: '$location', useFactory: (i: any) => i.get('$location'), deps: ['$injector'] },
        { provide: StartupService, useFactory: (i: any) => i.get('StartupService'), deps: ['$injector'] },
        { provide: 'routes', useFactory: (i: any) => i.get('routes'), deps: ['$injector'] },
    ],
})
export class Ng1UpgradeModule {}
